import { Component, OnInit } from '@angular/core';
import {AuthenticationService, UserService} from 'src/app/_services';
import {Router} from '@angular/router';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.css']
})
export class PageHeaderComponent implements OnInit {

  public loggedInClient: any;
  constructor(private authenticationService: AuthenticationService, private router: Router) {
    this.authenticationService.loggedInClient.subscribe(user => this.loggedInClient = user);
  }

  ngOnInit(): void {
  }

  goToHome() {
    this.router.navigate(['/']).then(r => window.location.reload());
  }

  logout() {
    localStorage.removeItem('loggedInClient');
    this.router.navigate(['/']).then(r => window.location.reload());
  }
}
